import { api, handleApiError } from 'services';
import { ca } from 'date-fns/locale';

export const downloadFile = async ({
                                     base64,
                                     filename,
                                   }: {
  base64: string;
  filename: string;
}): Promise<void> => {
  try {
    const response = await fetch(base64);
    const blob = await response.blob();

    const url = URL.createObjectURL(blob);
    return createLinkAndDownload(url, filename);
  } catch (error) {
    console.error('Error downloading file:', error);
  }
};

export const downloadXmlFromBase64 = ({
                                        base64,
                                        filename,
                                      }: {
  base64: string;
  filename: string;
}) => {
  try {
    const bytes = base64ToBytes(base64);
    const xmlText = new TextDecoder('utf-8').decode(bytes);
    const blob = new Blob([xmlText], { type: 'application/xml;charset=utf-8' });

    const url = URL.createObjectURL(blob);
    return createLinkAndDownload(url, filename);
  } catch (error) {
    console.error('Error downloading file:', error);
  }
};

export const downloadJsonFromBase64 = ({
                                         base64,
                                         filename,
                                       }: {
  base64: string;
  filename: string;
}) => {
  try {
    const cleanBase64 = base64.includes(',') ? base64.split(',')[1] : base64;
    const json = JSON.parse(atob(cleanBase64));
    const blob = new Blob([JSON.stringify(json)], { type: 'application/json' });

    const url = URL.createObjectURL(blob);
    return createLinkAndDownload(url, filename);
  } catch (error) {
    console.error('Error downloading file:', error);
  }
};

export const downloadScheduledReport = async (reportId: number | string) => {
  try {
    const { data } = await api.get<{
      base64: string;
      ext: string;
      filename: string;
    }>(`/scheduled-reports/${reportId}/download`);

    const { base64, filename } = data;
    return downloadFile({ base64, filename });
  } catch (error) {
    console.error('Error downloading file:', error);
    throw handleApiError(error);
  }
};

export const downloadRestrictedEventJustificationFile = async (fileId: number | string) => {
  try {
    const { data } = await api.get<{
      base64: string;
      ext: string;
      filename: string;
    }>(`/restricted-materials/events/download-justification-file/${fileId}`);
    const { base64, filename } = data;
    return downloadFile({ base64, filename });
  } catch (error) {
    console.error('Error downloading file:', error);
    throw handleApiError(error);
  }
};

const base64ToBytes = (base64: string): Uint8Array => {
  const clean = base64.includes(',') ? base64.split(',')[1] : base64;
  const bin = atob(clean);

  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) {
    bytes[i] = bin.charCodeAt(i);
  }

  return bytes;
};

export const createLinkAndDownload = (url: string, filename: string) => {
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
